import cardValidator from 'card-validator';
import { addMethod, StringSchema } from 'yup';

import { createError } from '../helpers';

addMethod(StringSchema, 'cardExpiry', function validate() {
  const CARD_EXPIRY_REGEXP = /^(0[1-9]|1[0-2])\/([0-9]{2})$/i;

  return this.trim().test((value, context) => {
    if (!value) {
      return true;
    }

    if (!value.match(CARD_EXPIRY_REGEXP)) {
      return createError(context, 'cardExpiry');
    }

    const verification = cardValidator.expirationDate(value);

    if (verification.isValid) {
      return true;
    }

    return createError(context, 'cardExpiryDate');
  });
});
